import { HmacSHA256, enc } from 'crypto-js'

export const convertSignature = (data: string) => {
  // Unstable behaviour of process.env.REACT_APP_SECRET_KEY
  const secretKey = 'JxWCK%Fs4^++swjuC$SVyyAJk*AD9E$&'

  if (!secretKey) {
    throw new Error('REACT_APP_SECRET_KEY is not defined')
  }

  return HmacSHA256(data, secretKey).toString(enc.Hex)
}
